<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Email Newsletter', route: '/backoffice/newsletter/' }, { label: 'Modifica Email Newsletter', active: true }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">MODIFICA EMAIL NEWSLETTER</h1>
</section>


<section class="pb-16 mb-8 px-container">
    <form [formGroup]="formNewsletter" (ngSubmit)="onSubmit()">
        <div class="flex flex-col gap-8">                                                                
            <div class="w-full">
                <label>* Email</label>
                <input type="email" pInputText placeholder="Email" formControlName="email" name="email" id="email" required />
                <small class="text-red-600 block mt-4 font-medium" *ngIf="formNewsletter.get('email')?.hasError('required') && (formNewsletter.get('email')?.dirty || formNewsletter.get('email')?.touched)">L'email è obbligatoria!.</small>
                <small class="text-red-600 block mt-4 font-medium" *ngIf="formNewsletter.get('email')?.hasError('email') && (formNewsletter.get('email')?.dirty || formNewsletter.get('email')?.touched)">L'email deve essere valida!.</small>
            </div>                                                                     
            <div class="flex lg:flex-row flex-col gap-8">
                <div class="lg:w-1/2 w-full">
                    <button class="btn-outln-backoffice p-3 w-full font-medium" type="submit" [disabled]="!formNewsletter.valid">Modifica email</button>
                </div>
                <div class="lg:w-1/2 w-full">
                    <p-confirmPopup #confirmDeletePopupRef>
                        <ng-template pTemplate="headless" let-message>
                            <div class="border-round p-3">
                                <span class="text-base">{{ message.message }}</span>
                                <div class="flex align-items-center gap-2 mt-3">
                                    <p-button class="text-center btn-danger-backoffice p-2 w-full font-medium" (click)="onDelete()" label="Elimina" />
                                    <p-button class="text-center btn-outln-backoffice p-2 w-full font-medium" (click)="onAnnulla()" label="Annulla" />
                                </div>
                            </div>
                        </ng-template>
                    </p-confirmPopup>
                    <button class="btn-danger-backoffice p-3 w-full font-medium" type="button" (click)="onDeleteNewsletterPopup($event)">Elimina email</button>
                </div>
            </div>    
        </div>
    </form>
</section>